import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="panel p-10 max-w-md w-full text-center" data-testid="payment-cancel">
        <XCircle className="w-16 h-16 text-slate-500 mx-auto mb-4" />
        <h1 className="font-heading font-black text-2xl text-white">Checkout canceled</h1>
        <p className="text-slate-400 mt-2 text-sm">No charge was made. You can pick up where you left off anytime.</p>
        <div className="flex gap-3 justify-center mt-6">
          <Link to="/membership" className="btn-gold px-6 py-3 rounded-xl font-heading font-black">VIEW PLANS</Link>
          <Link to="/ebook" className="btn-ghost-gold px-6 py-3 rounded-xl font-bold">THE EBOOK</Link>
        </div>
      </div>
    </div>
  );
}
